import React, { useContext, useEffect } from 'react';

import { Section } from '@gogame/components';
import { FormContext } from '@gogame/form';

import { useExtraContext } from 'scenes/SmartRules/SmartRuleForm/ExtraContext';
import { CREATIVES_TARGET } from 'scenes/SmartRules/SmartRuleForm/constants';

import { CreativesPopulations } from './CreativesPopulations';

export const CreativesPopulationSection = () => {
  const { hasCreativesDimension } = useExtraContext();
  const { setFieldValue, values } = useContext(FormContext);

  useEffect(() => {
    if (!hasCreativesDimension && values?.[CREATIVES_TARGET]) {
      setFieldValue(CREATIVES_TARGET, undefined);
    }
  }, [hasCreativesDimension]);

  if (!hasCreativesDimension) {
    return null;
  }
  return (
    <Section title={'Creatives Population'}>
      <CreativesPopulations />
    </Section>
  );
};
